import { Button, Card, FilePicker, Group, IconHelp, Modal } from "@veneer/core";
import { useTranslation } from "react-i18next";
import "../../assets/css/views/activations/bulkActivationAssignment.css";
import { UseBulkActivationAssignment } from "../../hooks/activations/useBulkActivationAssignment";
import SimpleMessageModalWithOpenClose from "../../components/Modals/SimpleMessageModalWithOpenClose";
import LoaderModal from "../../components/Loader/loaderModal";

export default function BulkActivationAssignment() {
  const [t] = useTranslation("global");

  const {
    modalMessage,
    onClickHelper,
    onClickDownloadTemplate,
    loading,
    handleOnClickOpen,
    handleOnClickExit,
    openModal,
    onChangeFilePicker,
    onClear,
    fileName,
    errorFilePicker,
    buttonNext,
    submitInBulk,
    jsonDate,
    fileError,
  } = UseBulkActivationAssignment();

  return (
    <>
      <div className="title-bulkActivationAssignment">
        <h4>{t("modal.massAssignmentActivations")}</h4>
      </div>

      <SimpleMessageModalWithOpenClose
        showModal={modalMessage.show}
        setOpenCloseModal={modalMessage.onClose}
        modalTitle={modalMessage.title}
        modalMessage={modalMessage.message}
      />

      {loading && (
        <div>
          <LoaderModal>
            <div>{t("header.generating")}</div>
          </LoaderModal>
        </div>
      )}

      <div style={{ position: "relative" }}>
        <Modal
          align="start"
          id="modal-id"
          show={openModal}
          onClose={() => handleOnClickExit()}
          title={t("modal.massAssignmentActivations")}
          footer={
            <Group>
              <Button onClick={() => handleOnClickExit()}>
                {t("header.closebutton")}
              </Button>
              <Button
                appearance="secondary"
                disabled={buttonNext}
                onClick={() => submitInBulk(jsonDate)}
              >
                {t("header.sendButton")}
              </Button>
            </Group>
          }
        >
          <FilePicker
            id="file-picker"
            onChange={(event, files, inputValue) =>
              onChangeFilePicker(event, files, inputValue)
            }
            className="modalSellOutFile"
            label={t("header.uploadFile")}
            accept=".xlsx"
            onClear={() => onClear()}
            value={fileName}
            error={errorFilePicker}
            helperText={fileError}
          />
        </Modal>
      </div>

      <Card
        appearance="outlined"
        content={
          <div className="buttons-containerBulkActivationAssignment">
            <div className="left-buttonsBulkActivationAssignment">
              <Button onClick={() => handleOnClickOpen()}>
                {t("header.uploadFile")}
              </Button>

              <div className="tooltipBulkActivationAssignment">
                <span className="tooltiptextBulkActivationAssignment">
                  {t("modal.titleHelper").replace(":", "?")}
                </span>
                <Button
                  appearance="secondary"
                  style={{ marginLeft: "10px" }}
                  leadingIcon={<IconHelp />}
                  onClick={() => onClickHelper()}
                ></Button>
              </div>
            </div>

            <div className="right-buttonsBulkActivationAssignment">
              <Button onClick={() => onClickDownloadTemplate()}>
                {t("header.downloadTemplate")}
              </Button>
            </div>
          </div>
        }
      />
    </>
  );
}
